import type { PasswordChangeFormValues } from '../types/password-change-form-values.type';

export const passwordChangeForm2ApiMapper = ({
  currentPassword,
  newPassword,
}: PasswordChangeFormValues) => ({ currentPassword, newPassword });
